module.exports = __webpack_public_path__ + "static/image-lin-manuel-miranda-119a3e9c698d31acd370a49d7da3f65a.png";